import * as React from "react"

const BoxFast = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 248.45 115.33"
    {...props}
  >
    <title>{"home-5-box-fast-2"}</title>
    <path
      fill="#317d6e"
      d="m248.44 57.52-33.21 57.52-66.42.01 33.21-57.53h66.42z"
    />
    <path fill="#b9d816" d="M148.81 0h66.42l33.22 57.52h-66.43L148.81 0z" />
    <path
      fill="#4ead90"
      d="m148.89 0-33.13 57.52 33.13 57.53 33.13-57.53L148.89 0z"
    />
    <path
      fill="#b9d816"
      d="M169.78 36.45H54.06l3.49 6.05 115.72-.01-3.49-6.04zM159.26 18.23l-115.72-.01 3.49 6.05 115.72.01-3.49-6.05zM148.74.01 33.02 0l3.49 6.05 115.73.01-3.5-6.05z"
    />
    <path
      d="M147.28 109.33H31.56l3.49 6h115.73Zm-10.52-18.22H21l3.49 6h115.77Zm-10.52-18.22H10.52l3.48 6h115.74Zm-10.52-18.22H0l3.5 6.06h115.72Z"
      fill="#4ead90"
    />
  </svg>
)

export default BoxFast
